import styled from 'styled-components';
import ds from 'designsystem';

const Header4 = styled.h4`
    color: ${ds.brand('text')};
    font-size: ${ds.fs('m')};
    font-family: ${ds.get('type.fontFamily.headline')};
    font-weight: ${ds.get('type.fontWeight.bold')};
    line-height: ${ds.get('type.lineHeight.base')};
    margin: 36px 0 24px;
`;

export default Header4;



// WEBPACK FOOTER //
// ./src/elements/Header4.js